import React ,{  useEffect, useContext,useState }from 'react'
import * as API from '../utils/APICalls'
import * as helpers from '../utils/helpers'
import { AppContext } from "../context/AppProvider";
import { DataGrid } from '@mui/x-data-grid'
import { Box, Button, Card, Container, Divider, IconButton, Input, InputAdornment, List, ListItem, ListItemIcon, MenuItem, Paper, Select, Stack, Switch, Pagination, Tooltip, Typography } from '@mui/material';
import ListenerInfoModal from './ListenerInfoModal';


const Listeners = ({artist, view}) => {
    const [  listeners, setListeners ] = useState([])
    const [ selectedListener, setSelectedListener ] = useState()
    const [ listenerModalOpen, setListenerModalOpen ] = useState(false)

     const handleViewListener = async (row) => {
        // Perform action with the row data
        // window.open(row?.location?.url,'_blank')
    if (view === 'console'){
      setSelectedListener(row)
      setListenerModalOpen(true)
     
    }
    // else{
    
    //   setSelectedListener(row)
    //   setEventDetailModalOpen(true)
    // }
      };
     const listenerColumns = [
        {
          field: 'view',
          headerName: 'view',
          width: 80,
          // editable: true,
          renderCell: (params) => {
            // if (!params.row?.location?.url) {
              return (
                <Button
                  variant="contained"
                //   color={BtnStatusColor(params.row)}
                  size="small"
                  // disabled={!params.row?.location?.url}
                  onClick={() => handleViewListener(params.row)}
                >
                  view
                </Button>
              );
            // } 
    
          },
        },
        {
          field: 'email',
          headerName: 'email',
          width: 120,
        //   renderCell: (params) => {
        //     return helpers.formatedEventDate(params.row?.date)
        //    } 
        },
        { field: 'preferredName', headerName: 'pref. name', width: 100,
          renderCell: (params) => {
            if(!params.row?.isVerified){
                return <span style={{color:'#FF0000', cursor:'pointer'}}
                onClick={()=>{
                    navigator.clipboard.writeText(params?.row?.pin)
                    .then(() => {
                        alert(`${params?.row?.pin} successfully copied`);
                    })
                }}
                >{params?.row?.pin}</span>
            }
            else{

                return params.row?.preferredName
            }
            } 
    
        },
        { field: 'subscriptions', headerName: 'sub tier', width: 70,
            renderCell: (params) => {
                const subs = params.row.subscriptions
                const sub = subs[0]
                if(sub){
                    if (sub?.isActive){
                        return sub?.title
                    }else{
                        return <b style={{color:'#FF0000'}}>{sub?.title}</b>
                    }
                }else{
                    return(
                        <Button
                        variant="contained"
                      //   color={BtnStatusColor(params.row)}
                        size="small"
                        // disabled={!params.row?.location?.url}
                        // onClick={() => }
                      >
                        msg
                      </Button>
                    )
                }
              } 
      
          },
        { field: 'updatedAt', headerName: 'last active', width: 150,
            renderCell: (params) => {
            return helpers.formatDateToLocal(params.row.updatedAt)
              } 
      
          },
        { field: 'listens', headerName: 'listens', width: 50,
          renderCell: (params) => {
          return params.row?.listens?.length
            } 
    
        },
        // { field: 'event_name', headerName: 'Event', width: 90 },
        {
          field: 'shares',
          headerName: 'shares',
          width: 50,
          renderCell: (params) => {
            let shareCount = 0
            const shares = params.row?.shares
            shares?.forEach(s=>{
              shareCount += s?.emails?.length
            })
            return shareCount
          
            } 
        },
       
       
        ];

    useEffect(()=>{
        const fetchListeners = async () =>{
            const res = await API.fetchArtistListeners(artist?._id)
            if ( res ){
                setListeners([...res])
            }else{ console.log(' No Listeners Found')}
        }
        fetchListeners()
    },[])

    useEffect(()=>{
        
    },[listeners])

  return (<>{listeners?.length > 0 ? 
                      <DataGrid
                        rows={listeners}
                        columns={listenerColumns}
                        getRowId={(row) => row?._id}
                        // getRowId={(row) => listeners?.indexOf(row)}
                        initialState={{
                        pagination: {
                            paginationModel: {
                            pageSize: 10,
                            // color:'#00ff00'
                            },
                        },
                        }}
                          components={{
                            Pagination: (props) => (
                            <Pagination {...props} className="custom-pagination" />
                            ),}}
                        // getRowClassName={() => 'share-row-text-color'}
                        pageSizeOptions={[5]}
                        // checkboxSelection
                        disableRowSelectionOnClick
                        sx={{
                          width:'100%',
                          padding:'0.5rem',
                        //    border:'1px solid #000', borderRadius:'5px',
                    //   boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)',
                    '& .MuiTablePagination-root': {
                        color: '#FF00FF', // Main text color
                    },
                    // '& .MuiTablePagination-selectLabel': {
                    //     color: '#00ff00', // "Rows per page" label color
                    // },
                    // '& .MuiTablePagination-select': {
                    //     color: '#00FF00', // Dropdown text color
                    // },
                    // '& .MuiTablePagination-displayedRows': {
                    //     color: '#FF00FF', // Displayed rows text color
                    // },
                    }}
                    />:<Stack sx={{margin:'auto', gap:'0.5rem',textAlign:'center'}}>
                    <span> No Listeners Listed.</span></Stack>}
                    <ListenerInfoModal
                    listener={selectedListener}
                    listenerModalOpen={listenerModalOpen} 
                    setListenerModalOpen={setListenerModalOpen} 
                    />
                    </>
  )
}

export default Listeners